import script from "./ResetPasswordPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPasswordPage.vue?vue&type=script&setup=true&lang=js"

import "./ResetPasswordPage.vue?vue&type=style&index=0&id=58bf49f1&lang=scss"

const __exports__ = script;

export default __exports__